
import { format } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
import { de } from "date-fns/locale";

export const formatDate = (date: Date): string => {
  return formatInTimeZone(date, "Europe/Zurich", "dd.MM.yyyy", { locale: de });
};

export const formatTime = (date: Date): string => {
  return formatInTimeZone(date, "Europe/Zurich", "HH:mm", { locale: de });
};

export const formatMonth = (date: Date): string => {
  return formatInTimeZone(date, "Europe/Zurich", "MMMM yyyy", { locale: de });
};

export const roundTo5Rappen = (amount: number): number => {
  return Math.round(amount * 20) / 20;
};
